// 发布订阅机制
import mitt from 'mitt'
const bus = mitt()
export default bus;